export default function PHP_MagicConstants() {
  return (
    <div>
      <h1>PHP_MagicConstants</h1>
    </div>
  );
}
